module.exports = __webpack_public_path__ + "../resources/img/storebadge_en.db9b21a1.png";